import React, { Component } from 'react'
import Avatar from 'material-ui/Avatar'
import { bindActionCreators, compose } from 'redux'
import { changePassword } from '../modules/authProfile'
import ChangePasswordFormDialog from '../components/changePasswordFormDialog'
import ShowAdminsDialog from '../components/showAdminsDialog'
import { connect } from 'react-redux'
import Divider from 'material-ui/Divider'
import { fetchForgotPasswordUser } from '../modules/forgotPassword'
import { fetchStockSecurityQuestions } from '../modules/securityQuestionsFormDialog'
import List from 'material-ui/List'
import { ListItem, ListItemAvatar, ListItemText } from 'material-ui/List'
import Paper from 'material-ui/Paper'
import PasswordIcon from 'material-ui-icons/Lock'
import { resetPassForm } from '../modules/changePasswordFormDialog'
import { resetSecurityForm } from '../modules/securityQuestionsFormDialog'
import SecurityIcon from 'material-ui-icons/Security'
import SupervisorAccountIcon from 'material-ui-icons/SupervisorAccount'
import SecurityQuestionsFormDialog from '../components/securityQuestionsFormDialog';
import { setSecurityQuestion } from '../modules/authProfile'
import { showPasswordDialog } from '../modules/changePasswordFormDialog'
import { showSecurityQuestionsDialog } from '../modules/securityQuestionsFormDialog'
import { showAdminsDialog, filterAdminsForUser } from '../modules/user'


import withStyles from 'material-ui/styles/withStyles'
import Messages from '../constants/messages';

const styles = theme => ({
  divider: {
    margin: '1em'
  },
  paper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    margin: 'auto',
    maxWidth: '35em',
    paddingBottom: '1em'
  },
  name: {
    fontSize: '2em',
    fontWeight: '500'
  },
  title: {
    margin: 'auto',
    padding: '1em'
  },
  userInfoList: {
    margin: 'auto',
  },
  userInfoItem: {
    display: 'inline'
  }
})

class Profile extends Component {
  componentDidMount() {
    const {
      fetchStockSecurityQuestions,
      securityQuestionsList,
      users,
      userPartners,
      filterAdminsForUser } = this.props

    if(!(securityQuestionsList && securityQuestionsList.length)) {
      fetchStockSecurityQuestions()
    }
    if (users.length > 0) {
      filterAdminsForUser({ users, userPartners });
    }
  }

  render() {

    const {
      changePassword,
      classes,
      email,
      firstName,
      hasSetSecurityQuestion,
      lastName,
      openChangePasswordDialog,
      openSecurityQuestionDialog,
      resetPassForm,
      resetSecurityForm,
      securityQuestionsList,
      setSecurityQuestion,
      showPasswordDialog,
      showSecurityQuestionsDialog,
      showAdminsDialog,
      openAdminsDialog,
      userId,
      users,
      userPartners,
      admins } = this.props

    return (
      <div>
        <ChangePasswordFormDialog
          initiatePasswordChange={changePassword}
          open={openChangePasswordDialog}
          resetForm={resetPassForm}
          showPasswordDialog={showPasswordDialog}
          title={Messages['uiComponents']['CHANGE_PASSWORD_LABEL']}
          userId={userId}>
        </ChangePasswordFormDialog>
        <SecurityQuestionsFormDialog
          email={email}
          hideCancelBtn={!hasSetSecurityQuestion}
          open={openSecurityQuestionDialog || !hasSetSecurityQuestion}
          resetForm={resetSecurityForm}
          securityQuestionsList={securityQuestionsList}
          setSecurityQuestion={setSecurityQuestion}
          showSecurityQuestionsDialog={showSecurityQuestionsDialog}
          title={hasSetSecurityQuestion ? Messages['uiComponents']['CHANGE_SECURITY_QUESTION_TITLE'] : Messages['uiComponents']['SET_SECURITY_QUESTION_TITLE']} 
          userId={userId} />
        <ShowAdminsDialog
          showAdminsDialog={showAdminsDialog}
          open={openAdminsDialog}
          title="My Admins"
          users={users}
          userPartners={userPartners}
          admins={admins}
        />
        <Paper data-test-id='profilePage' className={classes.paper}>
          <div data-test-id='userInfo' className={classes.paper}>
            <h2 data-test-id= 'userInfoName' className={classes.name}>{firstName} {lastName}</h2>
            <dl data-test-id='userInfoItems' className={classes.userInfoList}>
              <dt className={classes.userInfoItem}>{Messages['uiComponents']["EMAIL_LABEL"]}</dt>
              <dd className={classes.userInfoItem}>{email}</dd>
            </dl>
          </div>
          <List data-test-id='profileActions'>
            <Divider className={classes.divider} />
            <ListItem data-test-id='actionChangePassword' button onClick={() => showPasswordDialog(true)}>
              <ListItemAvatar>
                <Avatar>
                  <PasswordIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={Messages['uiComponents']['CHANGE_PASSWORD_LABEL']}
              />
            </ListItem>
            <ListItem data-test-id='actionSetSecurityQuestion' button onClick={() => {
              showSecurityQuestionsDialog(true)
              }}>
              <ListItemAvatar>
                <Avatar>
                  <SecurityIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={Messages['uiComponents']['CHANGE_SECURITY_QUESTION_TITLE']}
              />
            </ListItem>
            <ListItem data-test-id='actionShowAdmins' button onClick={() => {
              showAdminsDialog(true)
              }}>
              <ListItemAvatar>
                <Avatar>
                  <SupervisorAccountIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={Messages['uiComponents']['SHOW_MY_ADMINS']}
              />
            </ListItem>
          </List>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  email: state.authProfile.email,
  firstName: state.authProfile.firstName,
  hasSetSecurityQuestion: state.securityQuestionsFormDialog.hasSetSecurityQuestion,
  lastName: state.authProfile.lastName,
  openChangePasswordDialog: state.changePasswordFormDialog.open,
  openSecurityQuestionDialog: state.securityQuestionsFormDialog.open,
  securityQuestionsList: state.securityQuestionsFormDialog.stockQuestions,
  userId: state.authProfile.userId,
  openAdminsDialog: state.user.openAdminsDialog,
  users: state.user.users,
  userPartners: state.authProfile.userPartners,
  admins: state.user.admins
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePassword,
  fetchForgotPasswordUser,
  fetchStockSecurityQuestions,
  setSecurityQuestion,
  showPasswordDialog,
  showSecurityQuestionsDialog,
  showAdminsDialog,
  resetPassForm,
  resetSecurityForm,
  filterAdminsForUser
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
)(Profile)